import React, { useMemo } from 'react';
import { RichTextReadOnly } from 'mui-tiptap';
import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import Highlight from '@tiptap/extension-highlight';
import Image from '@tiptap/extension-image';
import { Color } from '@tiptap/extension-color';
import { FontFamily } from '@tiptap/extension-font-family';
import { TaskList } from '@tiptap/extension-task-list';
import { TaskItem } from '@tiptap/extension-task-item';
import { TextStyle } from '@tiptap/extension-text-style';
import { JSONContent } from '@tiptap/react';

interface BlogRichTextReadOnlyProps {
  content: string | JSONContent;
}

const BlogRichTextReadOnly: React.FC<BlogRichTextReadOnlyProps> = ({ content }) => {
  const extensions = useMemo(() => [
    StarterKit.configure({
      heading: {
        levels: [1, 2, 3, 4],
      },
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
    Highlight,
    Image,
    TextStyle,
    Color,
    FontFamily,
    TaskList,
    TaskItem.configure({
      nested: true,
    }),
  ], []);

  return (
    <RichTextReadOnly
      content={content}
      extensions={extensions}
    />
  );
};

export default BlogRichTextReadOnly;
